import { FooterItem } from './components/FooterItem';
import { useFooterItems } from './hooks';

import type { FC } from 'react';

export interface FooterItemsProps {
  onClick?(): void;
}

export const FooterItems: FC<FooterItemsProps> = ({ onClick }) => {
  const footerItems = useFooterItems();

  return (
    <>
      {footerItems.map(({ path, label }) => (
        <FooterItem path={path} key={path} onClick={onClick}>
          {label}
        </FooterItem>
      ))}
    </>
  );
};
